import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Box, Card, CardContent, Typography } from '@mui/material';
import React from 'react';
import { DashboardStat } from '../../types';

interface StatCardProps {
  stat: DashboardStat;
}

export const StatCard: React.FC<StatCardProps> = ({ stat }) => {
  const getColorVariant = (color?: string) => {
    switch (color) {
      case 'success':
        return '#10b981';
      case 'warning':
        return '#f59e0b';
      case 'error':
        return '#ef4444';
      case 'info':
        return '#3b82f6';
      default:
        return '#6b7280';
    }
  };

  const getTrendIcon = (trend?: string) => {
    switch (trend) {
      case 'up':
        return <TrendingUpIcon sx={{ color: '#10b981', fontSize: 20 }} />;
      case 'down':
        return <TrendingDownIcon sx={{ color: '#ef4444', fontSize: 20 }} />;
      case 'neutral':
        return <TrendingFlatIcon sx={{ color: '#6b7280', fontSize: 20 }} />;
      default:
        return null;
    }
  };

  return (
    <Card sx={{ height: '100%', borderLeft: `4px solid ${getColorVariant(stat.color)}` }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {stat.label}
          </Typography>
          {stat.trend && getTrendIcon(stat.trend)}
        </Box>

        <Typography variant="h4" component="div" fontWeight="bold">
          {stat.value}
        </Typography>

        {stat.trendValue !== undefined && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            {stat.trend === 'up' ? '+' : stat.trend === 'down' ? '-' : ''}
            {stat.trendValue}% from last period
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard;
